import pino from 'pino';

/**
 * Pino logger for SERVER-SIDE logging only (Express routes, SSR, API handlers).
 * Logs are collected by Datadog Agent from stdout.
 *
 * For BROWSER-SIDE error logging (Redux thunks, client-side API calls),
 * use `datadogRum.addError()` instead - it provides better error correlation
 * with user sessions, proper indexing, and RUM session replay integration.
 *
 * @example Server-side usage:
 * import logger from '../logger/logger';
 * logger.info({ userId: '123' }, 'User logged in');
 * logger.error({ err }, 'Failed to process request');
 */
const logger = pino({
  level: process.env.NODE_ENV === 'production' ? 'info' : 'debug',
  formatters: {
    level: (label) => {
      return {
        level: label,
      };
    },
  },
});

export default logger;
